import { onReady } from './util/onReady';

const openItemFromHash = (accordionItem: HTMLBiAccordionElement) => {
    const itemHash = `#${accordionItem.getAttribute('id')}`;

    if (itemHash === decodeURIComponent(window.location.hash)) {
        accordionItem.open();
    }
};

const initiateAccordion = (accordion: HTMLBiAccordionGroupElement) => {
    const accordionItems = [...accordion.querySelectorAll<HTMLBiAccordionElement>('bi-accordion')];
    accordionItems.forEach((accordionItem) => {
        const itemHash = `#${accordionItem.getAttribute('id')}`;
        accordionItem.addEventListener('open', () => {
            history.replaceState(undefined, document.title, itemHash);
        });
        accordionItem.addEventListener('close', () => {
            if (!window.location.hash || itemHash !== decodeURIComponent(window.location.hash)) {
                return;
            }
            history.replaceState(undefined, document.title, ' ');
        });

        openItemFromHash(accordionItem);
    });
};

const initHashChange = () => {
    window.addEventListener(
        'hashchange',
        () => {
            const decodedHash = decodeURIComponent(window.location.hash);
            if (decodedHash.length <= 1) return;

            const section = document.querySelector<HTMLBiAccordionElement>(`bi-accordion${decodedHash}`);
            if (section) {
                openItemFromHash(section);
            }
        },
        { passive: true },
    );
};

onReady(() => {
    const accordions = document.querySelectorAll<HTMLBiAccordionGroupElement>('bi-accordion-group');
    if (accordions.length === 0) return;

    Array.from(accordions).forEach(initiateAccordion);
    initHashChange();
});
